function buildErrorRoutes({ routes, errorLoading, onEnter404, onLeave404 }) {
  return routes.concat([
    {
      path: 'serviceError',
      getComponent(location, cb) {
        System.import(
          /* webpackChunkName: "c_service-error" */ `${BASE_PATH}/src/components/ServiceError/ServiceError`,
        )
          .then(module => {
            cb(null, module.default);
          })
          .catch(errorLoading);
      },
    },
    {
      path: 'pageNotFound',
      onEnter: onEnter404,
      onLeave: onLeave404,
      getComponent(location, cb) {
        System.import(
          /* webpackChunkName: "c_not-found" */ `${BASE_PATH}/src/containers/NotFound/NotFound`,
        )
          .then(module => {
            cb(null, module.default);
          })
          .catch(errorLoading);
      },
    },
    {
      path: '*',
      onEnter: onEnter404,
      onLeave: onLeave404,
      getComponent(location, cb) {
        System.import(
          /* webpackChunkName: "c_not-found" */ `${BASE_PATH}/src/containers/NotFound/NotFound`,
        )
          .then(module => {
            cb(null, module.default);
          })
          .catch(errorLoading);
      },
    },
  ]);
}

function buildLegacyRoutes({ onEnterLegacyRoute }) {
  return [
    {
      path: '/account/info',
      onEnter: onEnterLegacyRoute,
    },
    {
      path: '/account/privacy',
      onEnter: onEnterLegacyRoute,
    },
    {
      path: '/account/notices',
      onEnter: onEnterLegacyRoute,
    },
    {
      path: '/account/artistMessages',
      onEnter: onEnterLegacyRoute,
    },
    {
      path: '/account/audioQuality',
      onEnter: onEnterLegacyRoute,
    },
    {
      path: '/account/upgrade',
      onEnter: onEnterLegacyRoute,
    },
    {
      path: '/account/billing',
      onEnter: onEnterLegacyRoute,
    },
  ];
}

function buildAnonymousRoutes({
  routes,
  AsyncDomain,
  redirectToMyMusic,
  onEnterStationLanding,
  onEnterFirstIntro,
}) {
  return routes.concat([
    {
      path: 'land/station/:stationId',
      onEnter: onEnterStationLanding,
    },
    {
      path: 'premium/welcome',
      onEnter: redirectToMyMusic,
    },
    {
      path: 'intro/:campaignId',
      onEnter: onEnterFirstIntro,
    },
  ]);
}

export default {
  buildErrorRoutes,
  buildLegacyRoutes,
  buildAnonymousRoutes,
};
